import React, { useEffect, useState } from 'react';
import { Form } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import moment from 'moment';
import get from 'lodash/get';

import {
  customerInfoformItems,
  renderFormItems,
  POIFormItems,
  getCustI18n,
  getBusinessI18n,
  BSNL_ATTR,
  generateUploadProps,
  INDIVIDUAL_CUT_TYPE,
  CUST_TYPE_ENU,
} from '@/utils';
import { StepFooter, Upload } from '@/components';

function CustomerInfo (props) {
  const {
    onNext,
    onPrevious,
    attrObj,
    occupationList,
    POICertTypeList,
    dispatch,
    searchCustInfo,
    custValueMap,
    custCertValue,
    modelKey,
    poiDefaultFileList,
    form: { getFieldsValue },
    dateFormat,
  } = props;
  const { TITLE, MARITAL_STATUS, INCOME_GROUP, ORGANISATION, PURPOSE, GENDER } = BSNL_ATTR;
  const { getFieldDecorator } = props.form;

  const [initialEnd, setInitialEnd] = useState(false);

  useEffect(() => {
    async function initial() {
      dispatch({
        type: 'business/qryAttrInfoBsnl',
        payload: {
          attrCodes: `${PURPOSE},${INCOME_GROUP},${ORGANISATION},${MARITAL_STATUS},${GENDER},${TITLE}`,
        },
        modelName: modelKey,
      });
      dispatch({ type: 'business/qryPOICertTypeList', payload: { custType: INDIVIDUAL_CUT_TYPE }, modelName: modelKey });
      dispatch({ type: 'business/qryOccupationList', payload: { custType: INDIVIDUAL_CUT_TYPE }, modelName: modelKey });
      await dispatch({
        type: 'business/qryCustDetail',
        payload: { custId: searchCustInfo.custId, custFlag: 'Y', custAttrValueFlag: 'Y' },
        modelName: modelKey,
      });
      setInitialEnd(true);
    }
    initial();
  }, []);

  async function handleContinue() {
    const { custType, BSNL_PURPOSE, BSNL_TITLE, middleName, firstName, lastName, BSNL_GENDER, poiEffDate, poiExpDate,
      birthdayDay, BSNL_MARITAL_STATUS, BSNL_INCOME_GROUP, BSNL_ORGANISATION, certType } = getFieldsValue();
    
    const custBasicInfo = {
      custType: i18n(get(CUST_TYPE_ENU.find(type => type.value === custType), 'label')),
      usageCode: BSNL_PURPOSE,
      paidFlag: 'Post Paid',
      title: BSNL_TITLE,
      fullName: middleName ? `${firstName} ${middleName} ${lastName}` : `${firstName} ${lastName}`,
      gender: get(get(attrObj, `${GENDER}.valueList`).find(g => g.value === BSNL_GENDER), 'valueMark'),
      dateOfBirth: birthdayDay,
      dateOfBirthForReview: moment(birthdayDay).format(dateFormat), // 考虑到有其他部分使用到dateOfBirth变量，所以这里不对它进行变动，只新增一个
      poiDto: poiDefaultFileList,
      custCertValue: {
        certTypeName: get(POICertTypeList.find(c => c.certTypeId === certType), 'certTypeName'),
        effDateForReview: poiEffDate ? poiEffDate.format(dateFormat) : undefined, // 给review页面展示用
        expDateForReview: poiExpDate ? poiExpDate.format(dateFormat) : undefined, // 给review页面展示用
        ...custCertValue,
      },
      maritalStatus: get(get(attrObj, `${MARITAL_STATUS}.valueList`).find(g => g.value === BSNL_MARITAL_STATUS), 'valueMark'),
      incomeGroup: get(get(attrObj, `${INCOME_GROUP}.valueList`).find(g => g.value === BSNL_INCOME_GROUP), 'valueMark'),
      organization: get(get(attrObj, `${ORGANISATION}.valueList`).find(g => g.value === BSNL_ORGANISATION), 'valueMark'),
    };
    await dispatch({ // 存到modelKey中，主要Review使用
      type: `${modelKey}/save`,
      payload: {
        customerInfo: {
          custBasicInfo,
        },
      },
    });
    onNext();
  }

  function handlePrevious() {
    onPrevious();
  }

  return (
    <div className="threeColumnWrap">
      <Form layout="inline">
        <div className="blockWrap closeFooter">
          <h3 className="blockTitle">{getCustI18n('CUSTOMER_INFO')}</h3>
          <h4 className="blockSubTitle">{getBusinessI18n('CUSTOMER_BASIC_INFO')}</h4>
          <div className="formItemBox">
            {renderFormItems(customerInfoformItems({
              attrObj,
              occupationList,
              defaultValueMap: custValueMap,
              disabled: true,
            }), getFieldDecorator)}
          </div>
          <h4 className="blockSubTitle">{getCustI18n('POI')}</h4>
          <div className="formItemBox">
            {renderFormItems(POIFormItems({
              certTypeList: POICertTypeList,
              disabled: true,
              defaultValueMap: custCertValue,
            }), getFieldDecorator)}
            {initialEnd && (
              <Form.Item label={i18n('ADDR_PROOF_FILE')}>
                {getFieldDecorator('poiAttach', {})(
                  <Upload
                    defaultFileList={poiDefaultFileList}
                    disabled
                    {...generateUploadProps({
                      dispatch,
                      i18n,
                    })}
                  />
                )}
              </Form.Item>
            )}
          </div>
        </div>
        <StepFooter onPrevious={handlePrevious} onContinue={handleContinue} />
      </Form>
    </div>
  );
}
export default Form.create({ name: 'customer-info' })(CustomerInfo);
